<div class="progress-circle">
  <div class="progress-chart">
    <div echarts [options]="options" class="chart" (chartInit)="onChartInit($event)"></div>
  </div>

  <div class="chart-info">
    <div class="chart-count">
      {{ totalCount }}
    </div>

    <div class="chart-title">
      {{ progressTitle }}
    </div>

    <button nz-button nzType="default" *ngIf="isTestCase" class="view-btn" [nzSize]="'small'" (click)="view()">Details</button>
  </div>
</div>

<app-view-test-case-progress #viewProgress [currentUser]="currentUser"></app-view-test-case-progress>
